import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollsInUseReport } from "./components/RollsInUseReport";

export const RollsInUsePage = () => {
	return (
		<>
			<HelmetDexteel title="Rolls in Use" />
			<RollsInUseReport />
		</>
	);
};
